import { makeStyles } from '@material-ui/core/styles';

const useLinkSpendModalStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
    },
    paper: {
        width: 'min(1180px, calc(100vw - 48px))',
        height: 'min(84vh, 780px)',
        maxHeight: 'calc(100vh - 48px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: '#fff',
        borderRadius: 10,
        boxShadow: '0 18px 50px rgba(25, 32, 56, 0.22)',
        outline: 'none',
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100vw - 24px)',
            height: 'calc(100vh - 24px)',
        },
    },
    header: {
        minHeight: 58,
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #E9EBF5',
        backgroundColor: '#FAFAFE',
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    title: {
        color: '#2B2C35',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '22px',
    },
    subtitle: {
        marginTop: 2,
        color: '#78798E',
        fontSize: 12,
        lineHeight: '17px',
    },
    toolbar: {
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        borderBottom: '1px solid #E9EBF5',
        flexWrap: 'wrap',
        flexShrink: 0,
    },
    search: {
        width: 260,
        '& .MuiOutlinedInput-root': {
            height: 34,
            fontSize: 12,
        },
    },
    filterButton: {
        height: 34,
        backgroundColor: '#1976d2',
        color: '#fff',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
    },
    selectionText: {
        marginLeft: 'auto',
        color: '#55576A',
        fontSize: 12,
    },
    filterPopper: {
        borderRadius: 10,
        boxShadow: '0 10px 19.6px 0 #E7E8EB',
        zIndex: 2200,
        maxHeight: 'min(70vh, 520px)',
        overflowY: 'auto',
        width: 420,
        maxWidth: '90vw',
    },
    filterFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: '16px',
        borderTop: '1px solid #e0e0e0',
    },
    content: {
        position: 'relative',
        padding: 12,
        overflow: 'auto',
        flex: 1,
        minHeight: 0,
    },
    loading: {
        minHeight: 240,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    footer: {
        minHeight: 60,
        padding: '12px 20px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 10,
        borderTop: '1px solid #E9EBF5',
        backgroundColor: '#FAFAFE',
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    cancelButton: {
        minWidth: 82,
        height: 34,
        color: '#3F51B5',
        borderColor: '#3F51B5',
        textTransform: 'none',
    },
    saveButton: {
        minWidth: 82,
        height: 34,
        color: '#fff',
        backgroundColor: '#3F51B5',
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#35469F',
            boxShadow: 'none',
        },
    },
}));

export default useLinkSpendModalStyles;
